import { useTranslation } from "react-i18next";
import PatientItem from "./patientItem";
import { useAuth } from "@mindlercare/auth-ui";
import { countries } from "@mindlercare/schema";

export const PersonalNumber = ({
  personalNumber,
}: {
  personalNumber?: string | number | null;
}) => {
  const { t } = useTranslation();
  const { market } = useAuth();

  if (market === countries.SE.codeISO2 && personalNumber) {
    return (
      <PatientItem title={t("NATIONAL_IDENTITY")} value={personalNumber} />
    );
  }

  return null;
};
